<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Allocate" active>
            <div class="border p-2">
              <div class="row">
                <div class="col-auto">
                  <span class="bg-primary text-white px-3 font-size-26">
                    {{ job.job_number }}</span
                  >
                </div>
                <div class="col">
                  <p class="text-muted mt-2 mb-0" v-if="job.manufacture">
                    {{ job.manufacture.description }} -
                    {{ job.device_type.description }}
                    <span v-if="job.device_model">
                      <br />
                      <strong>{{ job.device_model.code }}</strong> -
                      {{ job.imei_in ? job.imei_in : job.serial_in }}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div v-if="job.assessed_by" class="border border-info p-3">
              <small class="text-info my-2 font-weight-bold">ASSESSED BY</small>

              <div class="row mt-2">
                <div class="col-auto">
                  <b-avatar v-if="!job.assessed_by.image"></b-avatar>
                  <b-avatar
                    v-if="job.assessed_by.image"
                    :src="job.assessed_by.image"
                  ></b-avatar>
                </div>
                <div class="col">
                  <strong> {{ job.assessed_by.name }} </strong><br />
                  <small class="text-muted">
                    {{
                      moment(new Date(job.assessed_date)).format(
                        "DD MMM YY, HH:mm"
                      )
                    }}
                  </small>
                </div>
              </div>
            </div>

            <h5 class="font-weight-500 mt-5">Select a technician:</h5>
            <div class="row">
              <div class="col-md-6 col-lg-4 h-100 mb-2" v-for="u in users" :key="u.id">
                <div class="border p-2 selectable-div" @click="job.assessed_by_user_id=u.id;handleSubmit()">
                  <div class="row">
                    <div class="col-auto">
                      <b-avatar v-if="!u.image"></b-avatar>
                      <b-avatar
                        v-if="u.image"
                        :src="u.image"
                      ></b-avatar>
                    </div>
                    <div class="col pt-1">
                      <strong> {{ u.name }} </strong><br />
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </b-tab>

          <b-tab title="Client" v-if="job.client_id">
            <client :id="job.client_id" class="mt-3"></client>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <partner :id="job.partner_id" class="mt-3"></partner>
          </b-tab>

          <b-tab title="Job">
            <job-minimal :id="id"></job-minimal>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jobRepo from "@/api/repos/jobRepo";
import { required } from "vuelidate/lib/validators";

import partner from "@/views/modules/partners/show";
import client from "@/views/modules/clients/show";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";

export default {
  components: {
    partner,
    client,
    jobMinimal,
  },

  validations: {
    job: {
      assessed_by_user_id: {
        required,
      },
    },
  },

  props: ["id"],

  mounted() {
    this.getCreatedData(this.id);
  },

  data() {
    return {
      users: [],
      job: {},
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  methods: {
    async getCreatedData(id) {
      try {
        this.loading = true;
        let { data } = await jobRepo.awaitingAllocationCreate(id);
        this.users = data.users;
        this.job = data.job;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await jobRepo.awaitingAllocationStore({
            id: this.id,
            assessed_by_user_id: this.job.assessed_by_user_id,
          });
          this.$emit("awaitingAllocationCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

